let inFlightPillarsPromise = null;
let lastViewId = null;
let cachedPillars = null;

export const fetchAllPillarsCached = async (viewId, baseUrl = '') => {
  // Return cached data if available for this view
  if (lastViewId === viewId && cachedPillars) {
    return JSON.parse(JSON.stringify(cachedPillars)); // Return deep copy to prevent mutation
  }
  
  // Return in-flight promise if one exists for this view
  if (inFlightPillarsPromise && lastViewId === viewId) {
    const data = await inFlightPillarsPromise;
    return JSON.parse(JSON.stringify(data)); // Return deep copy
  }

  lastViewId = viewId;
  
  const url = `${baseUrl}/api/pillars/all?viewId=${viewId}`;
  
  inFlightPillarsPromise = fetch(url)
    .then(async (res) => {
      if (!res.ok) throw new Error(`Status: ${res.status} ${res.statusText}`);
      const data = await res.json();
      cachedPillars = data;
      return data;
    })
    .finally(() => {
      inFlightPillarsPromise = null;
    });

  const data = await inFlightPillarsPromise;
  return JSON.parse(JSON.stringify(data)); // Return deep copy
};

export const clearPillarsCache = () => {
  cachedPillars = null;
  lastViewId = null;
};
